import { render, staticRenderFns } from "./csi-company.vue?vue&type=template&id=9f92f82e&"
import script from "./csi-company.vue?vue&type=script&lang=js&"
export * from "./csi-company.vue?vue&type=script&lang=js&"
import style0 from "./csi-company.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports